import React from 'react';

import Illustration from './Illustration';
import Button from './Button';
import ArticleInfo from './ArticleInfo';

function ArticleCard({ article }) {
  const { coverImage } = article;
  return (
    <>
      {article && (
        <div className="article-card">
          {coverImage && (
            <div className="article-card__image">
              <Button
                button={{
                  version: 'wrapper',
                  article
                }}
              >
                <Illustration illustration={coverImage} />
              </Button>
            </div>
          )}
          <ArticleInfo article={article} />
        </div>
      )}
    </>
  );
}

export default ArticleCard;
